import { render, staticRenderFns } from "./WalletSelector.vue?vue&type=template&id=1052461c&scoped=true&"
import script from "./WalletSelector.vue?vue&type=script&lang=js&"
export * from "./WalletSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1052461c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1052461c')) {
      api.createRecord('1052461c', component.options)
    } else {
      api.reload('1052461c', component.options)
    }
    module.hot.accept("./WalletSelector.vue?vue&type=template&id=1052461c&scoped=true&", function () {
      api.rerender('1052461c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/generic/WalletSelector.vue"
export default component.exports